
export const getFilter = (state) => state.filter;
export const getUser =(state) => state.auth.user;
export const getIsLoggedIn = (state) => state.auth.isLoggedIn;


